import { TestCoverImage } from '@doltech/ui/lib/figma/CoverImage/CoverImageComponent';
import { Typography } from '@doltech/ui/lib/figma/DesignSystemV2/Typography';
import { Row } from 'antd';
import * as React from 'react';
import styled from 'styled-components';

import {
  BOTTOM_NAVIGATION_LEFT_BOOK_HEIGHT,
  BOTTOM_NAVIGATION_LEFT_BOOK_WIDTH,
  BOTTOM_NAVIGATION_LEFT_SECTION_WIDTH,
} from '../layouts/BottomNavigationLayout';

const TITLE_MAX_WIDTH =
  BOTTOM_NAVIGATION_LEFT_SECTION_WIDTH - BOTTOM_NAVIGATION_LEFT_BOOK_WIDTH - 8; // where 8 is margin

const Main = styled.div`
  .book-cover {
    width: 32px;
    height: ${BOTTOM_NAVIGATION_LEFT_BOOK_HEIGHT}px;
    object-fit: cover;
  }
  .text-content {
    margin-left: 8px;

    .title {
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      max-width: ${TITLE_MAX_WIDTH}px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .sub-title {
      max-width: ${TITLE_MAX_WIDTH}px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    span {
      white-space: pre-wrap;
    }
  }
`;

interface BottomNavigationLeftInfoProps {
  bookCover: string;
  title: string;
  desc: string;
}

export const BottomNavigationLeftInfo = ({
  bookCover,
  title,
  desc,
}: BottomNavigationLeftInfoProps) => {
  return (
    <Main className="bottom-navigation-left-info">
      <Row align="middle">
        <TestCoverImage className="book-cover" src={bookCover} alt={title} />
        <div className="text-content">
          <Typography.Title
            className="title"
            level={1}
            variant="semi-bold/14"
            ellipsis={{ tooltip: title }}
          >
            {title}
          </Typography.Title>
          <Typography.Paragraph
            variant="regular/12"
            color="gray100"
            className="sub-title"
            ellipsis={{ tooltip: desc }}
          >
            {desc}
          </Typography.Paragraph>
        </div>
      </Row>
    </Main>
  );
};
